import React from 'react';
export const ViewerContainerSizeContext = React.createContext(undefined);
ViewerContainerSizeContext.displayName = 'ViewerContainerSizeContext';

//# sourceMappingURL=ViewerContainerSizeContext.js.map